import React, {useContext, useState} from "react"
import {LoginForm} from "./login-form"
import {LoginFormViewModel} from "./login-form-viewmodel"
import {useServices} from "../../services/services"
import {UnauthenticatedUser, UserContext} from "../../services/authentication/user-context"
import {Redirect, useHistory} from "react-router-dom"
import {performWithApiCallErrorHandling} from "../../services/api/api-utils"
import {gaSendLoginEvent} from "../../services/analytics/google-analytics-helper"

export interface LoginProps {
  doNotRedirect?: boolean
}

export const Login: React.FC<LoginProps> = ({doNotRedirect}) => {
  const user = useContext(UserContext)
  const services = useServices()
  const history = useHistory()
  const [error, setError] = useState<string | undefined>(undefined)

  console.log("doNotRedirect", doNotRedirect)

  if (user !== UnauthenticatedUser) {
    return <Redirect to="/" />
  }

  const login = async (loginForm: LoginFormViewModel) => {
    if (services === null) return

    await performWithApiCallErrorHandling(async () => {
      await services.authenticationService.signIn(loginForm.email, loginForm.password)
      gaSendLoginEvent()
      if (!doNotRedirect) history.push("/dashboard")
    }, "Er is iets misgegaan tijdens het inloggen.", setError)
  }

  return <LoginForm onSubmit={login} error={error} />
}